import { z } from 'zod';

export const userBulkDeletionSchema = z
  .object({
    file: z.custom<File>(val => val instanceof File, 'CSVファイルを選択してください。'),
    registrationType: z.enum(['immediate', 'scheduled']),
    scheduledDate: z.date().optional(),
    scheduledTime: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.registrationType === 'scheduled') {
      if (!data.scheduledDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: '日付を選択してください。',
          path: ['scheduledDate'],
        });
      }
      if (!data.scheduledTime) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: '時刻を入力してください。',
          path: ['scheduledTime'],
        });
      }
    }
  });

export type UserBulkDeletionFormValues = z.infer<typeof userBulkDeletionSchema>;
